module.exports = __webpack_public_path__ + "static/media/solveButton.faa561d7.png";